import LoanMenu from "./LoanMenu";
import Card from "@nodes/@material-ui/core/Card";
import CardActions from "@nodes/@material-ui/core/CardActions";
import Divider from "@nodes/@material-ui/core/Divider";
import Grid from "@nodes/@material-ui/core/Grid";
import CardHeader from "@nodes/@material-ui/core/CardHeader";
import IconButton from "@nodes/@material-ui/core/IconButton";
import { FaRegMoneyBillAlt } from "@nodes/react-icons/fa";
import PersonIcon from "@nodes/@material-ui/icons/Person";
import CardContent from "@nodes/@material-ui/core/CardContent";
import Typography from "@nodes/@material-ui/core/Typography";
import { makeStyles } from "@nodes/@material-ui/core";
import { printDate, newDate, printAbsAmount, getBadgeColor } from "../functions";
import { useHistory } from "@nodes/react-router-dom";

const useStyles = makeStyles(() => ({
  CardContent: {
    paddingTop: 0,
  },
}));

const LoanCard = ({ loan }) => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <Card raised className="mb-1">
      <CardHeader
        action={<LoanMenu history={history} loan={loan} />}
        title={
          <Typography variant="h6" component="h4">
            {loan.name}
          </Typography>
        }
        subheader={
          <>
            <Typography variant="body2" component="p">
              Balance {printAbsAmount(loan.balance)}
            </Typography>
            <Typography variant="body2" component="p">
              Ultimo Pago: {printDate(newDate(loan.last_date), "dd-MMM-y")}
            </Typography>
          </>
        }
      />
      <CardContent className={classes.CardContent}>
        <Typography variant="body1" component="p">
          Entregado en: {printDate(newDate(loan.given_date), "dd-MMM-y")}
        </Typography>

        <Typography variant="body1" component="p">
          Monto Prestado: {printAbsAmount(loan.amount)}
        </Typography>

        <Typography variant="body1" component="p">
          Cuotas Pagas: {printAbsAmount(loan.wPayment)} | {loan.completed} / {loan.npayments}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions disableSpacing>
        <Grid container>
          <Grid item xs={6}>
            <IconButton
              aria-label="add sector"
              onClick={() => history.push(`/payment/create/${loan.money_id}/${loan.debtor_id}`)}>
              <FaRegMoneyBillAlt className="text-success" />
            </IconButton>
            <IconButton aria-label="share" onClick={() => history.push(`/debtor/profile/${loan.dUniqueId}`)}>
              <PersonIcon />
            </IconButton>
          </Grid>
          <Grid item xs={6} align="right">
            {loan.statusText === "Al Dia" ? (
              <Typography variant="subtitle2" component="p" className="badge badge-pill badge-success">
                <i>{loan.statusText}</i>
              </Typography>
            ) : (
              <Typography variant="subtitle2" component="p" className={getBadgeColor(loan.statusText)}>
                <i>
                  {loan.statusText}: {printAbsAmount(loan.statusAmount)}
                </i>
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default LoanCard;
